import { StepOptions } from 'features/ActivationClient/shared/step-options';
import { initialModalTemplates as modalTemplates } from '../context';

export const wizardInitialState = {
  currentStep: 0,
  stepsState: {
    [StepOptions.Client]: {
      name: 'asdasdasda',
      surname: 'asdasdasd',
      sex: 'M',
      date: new Date(2000, 0, 1),
      phoneType: 'FIJO',
      areaCode: '11',
      phoneNumber: '12454359',
      phoneCompany: 'Claro',
      email: 'alexis.patino@globallogic.com',
      risk: { reason: 'FALLO  CONEXION CON VERAZ', risk: 'M' },
    },
    [StepOptions.Domicile]: {
      canProceed: true,
      selectedAddress: {
        addressFloor: '7',
        addressFlat: 'A',
        addressTower: '2',
        addressWithinStreets:
          'Pieces of Eight Plate Fleet hang the jib Davy Jones Locker cable Spanish Main clap thunder hogshead stern lass bowsprit Jack Tar brigantine red ensign. Sail ho lateen sail bilge rat cog clipper squiffy hearties dead men tell no tales killick flogging',
        addressObservations:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc dignissim viverra orci, in imperdiet leo viverra vestibulum. Maecenas finibus enim non sem aliquet, eu aliquet leo aliquet. Proin consectetur cursus massa a cursus. Aliquam ornare felis',
        latitude: '-65,42367201',
        longitude: '-24,72223175',
        addressStreet: 'M527A',
        addressNumber: '10',
        addressCity: 'SALTA',
        addressDepartment: 'SALTA',
        regionName: 'SALTA',
        descripcion: 'M527A 10 MZ: M527A LT: 10, SALTA, SALTA, SALTA',
        cpa: '4400',
        CodigoPostal: '4400',
        Manzana: 'M527A',
        Lote: '10',
        IdLocalidad: '1153',
        Tecnologia: 'GPON',
        Edificio: '',
        HabilitadoVenta: true,
      },
      isConfirmed: true,
      isOpenCobertura: false,
      sds: {
        listSds: [
          {
            sds: '00003004TAE',
            date: '2019-11-24 14:58:31.0',
            status: 'RECHAZADO',
            motivo: 'Sin motivo',
            short_description: 'Sin motivo',
          },
        ],
        message: {
          status: 'OK',
          title: '¡Buenísimo! Podés avanzar con el pedido.',
          subtitle: 'El domicilio no tiene ninguna visita pendiente.',
        },
      },
      sdsLoading: false,
      sdsError: null,
    },
    [StepOptions.PlansServices]: {
      formInitialValues: {
        serviceType: '',
        campaignType: '',
        promotionType: '',
        internetType: '',
        decoQuantity: 0,
      },
      selectedOptions: {
        paramsCampaign: {
          technology: 'GPON',
          service_type: 'IF',
          identification_type: 'CI',
          identification_number: '45636334',
          business: 'FIJO',
          entity_id: '593316',
          is_client: 'N',
          sex: 'M',
          client_id: '',
          user_name: 'VENTASDEV',
          address_id: '',
        },
        paramsPromotions: {
          technology: 'GPON',
          business_type: 'IF',
          service_type: 'IF',
          identification_number: '95708775',
          identification_type: 'CI',
          entity_id: '593316',
          deal: 'FIJO',
          principal: 'S',
          username: 'VENTASDEV',
          is_client: 'N',
          sex: 'M',
          client_id: '',
        },
        paramsInternet: {
          technology: 'GPON',
          business_type: 'FIJO',
          service_type: 'IF',
          identification_number: '95708775',
          identification_type: 'CI',
          entity_id: '593316',
          principal: 'S',
          is_client: 'N',
          province: 'BUENOS AIRES',
          location: '30',
          zip_code: '1875',
          sales_channel: '254',
          sex: 'M',
          username: 'VENTASDEV',
          client_id: '',
        },
      },
      plans: [
        {
          planId: 'I100M',
          planDescription: 'Internet Ilimitado 100MB',
          planDebit: 'O',
          planOrder: '100',
          lineType: {
            id: 'IF',
            order: 1,
          },
          blockCode: 'FIINT',
          cluster: '16',
          product: {
            prodId: 4014506,
            description: 'ONT GPON Genérica',
            chargeId: 'S3180',
            goalPrice: null,
            level: 1,
            debit: 'O',
            detailId: 45578,
            ownId: 'CTI',
            typeContract: 'COMO',
          },
        },
        {
          planId: 'TELIP',
          planDescription: 'Telefonía Fija',
          planDebit: 'O',
          planOrder: null,
          lineType: {
            id: 'TF',
            order: 2,
          },
          blockCode: 'L1400',
          cluster: '16',
          product: {
            prodId: 4014506,
            description: 'ONT GPON Genérica',
            chargeId: 'S3180',
            goalPrice: null,
            level: 1,
            debit: 'O',
            detailId: 45578,
            ownId: 'CTI',
            typeContract: 'COMO',
          },
        },
      ],
      summaryData: {
        amount: '1199.00',
        costs: [
          {
            planId: 'M20IF',
            planDescription: 'Internet Ilimitado 20MB',
            lineType: 'IF',
            amount: 439.0001,
            marketingParametersList: [
              {
                chargeId: 'TYC257',
                chargeDescription: 'TYC 257',
              },
              {
                chargeId: 'M20BRF',
                chargeDescription: 'PACK DE VELOCIDAD 20MB',
              },
              {
                chargeId: 'BFPRIF',
                chargeDescription: 'BONIF. PRORRATEO IF',
              },
              {
                chargeId: 'PRSALT',
                chargeDescription: 'BONIFICACION SALTA',
              },
              {
                chargeId: 'WIFIFI',
                chargeDescription: 'PACK WIFI FIJO',
              },
            ],
          },
          {
            planId: 'TEFIJ',
            planDescription: 'Telefonía Fija',
            lineType: 'TF',
            amount: 60.0039,
            marketingParametersList: [
              {
                chargeId: 'TYC257',
                chargeDescription: 'TYC 257',
              },
              {
                chargeId: 'CPPOFF',
                chargeDescription: 'COMUNICACIONES A MOVILES OFF',
              },
              {
                chargeId: 'PLIFHG',
                chargeDescription: 'PACK LLAMADAS ILIM A FIJO MOVI',
              },
              {
                chargeId: 'BFCOTF',
                chargeDescription: 'BONIF. ABONO TF',
              },
              {
                chargeId: 'CPPONT',
                chargeDescription: 'COMUNICACIONES A MOVILES ON',
              },
              {
                chargeId: 'PACBAS',
                chargeDescription: 'PACK BASICO FIJA',
              },
            ],
          },
        ],
        credits: [
          {
            planId: 'I100M',
            lineType: 'IF',
            description: 'Bonificación abono Internet 100% x 3 meses',
            amount: null,
          },
        ],
      },
    },
  },
  stepsCount: 4,
  flowCompleted: false,
  currentModal: modalTemplates.EXIT_PROCESS,
  isLastStep: false,
  showNextButton: true,
  showPreviousButton: true,
};

// CHANGE STEPOPTIONS.PLANS
export const wizardInitialStateDTH = {
  ...wizardInitialState,
  currentStep: 2,
  historyCancel: '/claro-tv',
  modalTemplates,
  stepsState: {
    ...wizardInitialState.stepsState,
    [StepOptions.Domicile]: {
      ...wizardInitialState.stepsState[StepOptions.Domicile],
      selectedAddress: {
        ...wizardInitialState.stepsState[StepOptions.Domicile].selectedAddress,
        Tecnologia: 'DTH',
      },
    },
    [StepOptions.PlansServices]: {
      ...wizardInitialState.stepsState[StepOptions.PlansServices],
      selectedOptions: {
        ...wizardInitialState.stepsState[StepOptions.PlansServices]
          .selectedOptions,
        paramsCampaign: {
          ...wizardInitialState.stepsState[StepOptions.PlansServices]
            .selectedOptions.paramsCampaign,
          technology: 'DTH',
          business: 'TV',
          service_type: 'DTH',
          company_id: '1',
          is_employee: false,
          main_line: 'S',
          main_iptv_for_sale: 'N',
          special_line_type: 'N',
        },
      },
    },
  },
};
